import { render, staticRenderFns } from "./PhysicianDutyOnPayroll.vue?vue&type=template&id=25ea4dd0&"
import script from "./PhysicianDutyOnPayroll.vue?vue&type=script&lang=js&"
export * from "./PhysicianDutyOnPayroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports